import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42896455"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute top-0 left-0 right-0 bottom-0" }
const _hoisted_2 = { class: "absolute top-0 left-0 right-0 bottom-0 z-10 flex justify-center items-center flex-col gap-8" }
const _hoisted_3 = {
  key: 0,
  class: "text-5xl text-primary"
}
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center bg-sky-50"
}
const _hoisted_5 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_6 = {
  key: 3,
  class: "flex justify-center pt-16 pb-24"
}
const _hoisted_7 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "text-2xl" }
const _hoisted_12 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_13 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "text-2xl w-" }
const _hoisted_18 = ["onMouseenter", "onMouseleave"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "relative"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute right-4 top-4 tile-indicator mt-0.5 w-1 h-1" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "flex justify-between items-end p-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tile-indicator w-5 h-1 2xl:my-3 2xl:ml-4" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute right-4 top-4 tile-indicator mt-0.5 w-1 h-1" })
], -1))
const _hoisted_25 = { class: "px-6 py-2 w-full animate-fadeIn" }
const _hoisted_26 = {
  class: "block py-2",
  style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "container grid grid-cols-2 items-center text-primary" }
const _hoisted_29 = { class: "flex justify-center text-5xl font-bold" }
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "flex flex-col text-sm 2xl:text-base" }

import { ref, computed, shallowRef, reactive, onMounted } from 'vue';
import { useMeta, Notify } from 'quasar';
import { treeToList } from 'src/utils/tree';
import SvCarousel from 'src/components/SvCarousel.vue';
import SvProductTabs from 'src/components/SvProductTabs.vue';
import SvProductENTabs from 'src/components/SvProductENTabs.vue';
import SvDocumentCards from 'src/components/SvDocumentCards.vue';
import SvThumbnail from 'src/components/SvThumbnail.vue';
import AppLink from 'src/components/AppLink.vue';
import { useMetaStore } from 'src/stores/modules/meta';
import { useI18n } from 'vue-i18n';
import { create } from 'src/api/Message';
import { vertifySmsSecurityCode } from 'src/utils/sms';
import VueScrollTo from 'vue-scrollto';
import { useRoute } from 'vue-router';
import tmpl from 'src/utils/tmpl';

type ModelType = {
  name: string;
  country?: string;
  company?: string;
  content: string;
  phone?: string;
  email?: string;
  about: string[];
  securityCode?: string;
};


import { useLayoutStore } from 'src/stores/modules/layout';
import { usePageStore } from 'stores/modules/page';
import { useArticleStore } from 'stores/modules/article';
import { RegionDto } from 'src/api/types';

const dark = process.env.THEME === 'dark';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ url: currentRoute.path });

    const articleStore = useArticleStore(store);
    await articleStore.fetchList({
      isActive: true,
      skipCount: 0,
      maxResultCount: 10,
    });

    const layoutStore = useLayoutStore(store);
    await layoutStore.fetch({ url: '^$' });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
onMounted(() => {
  if (route.hash) {
    VueScrollTo.scrollTo(route.hash, {
      offset: -124,
    });
  }
});
const IndoorProductOpen = ref(false)
const OutdoorProductOpen = ref(false)
const CounterProductOpen = ref(false)
const layoutStore = useLayoutStore();

const pageHeight = layoutStore.layout.regions.includes((t: any) =>
  /^header-top/.test(t.name)
)
  ? 'calc(100vh - 5rem)'
  : 'calc(100vh - 4rem)';

  const pageHeightTwo = layoutStore.layout.regions.includes((t: any) =>
  /^header-top/.test(t.name)
)
  ? 'calc(150vh - 5rem)'
  : 'calc(150vh - 4rem)';

const gridRow = 24;
const gridRowHeight = computed(() => {
  return `calc(${pageHeightTwo} / ${gridRow})`
})

const gridRowSelectHeight = computed(() => {
  return `calc(${pageHeightTwo} / ${gridRow / 3})`
})

const { locale, t } = useI18n();
const isEnglish = computed(() => locale.value === 'en-US');

// const videoPlayerVisible = ref<boolean>(false);
const videoFullscreen = ref<boolean>(false);
// const carouselAutoplay = ref<boolean | number>(8000);

const player = shallowRef();
const handleMounted = (payload: any) => {
  player.value = payload.player;
  player.value?.play();
};

// const handlePlay = () => {
//   const button = document.getElementsByClassName(
//     'vjs-fullscreen-control'
//   )[0] as HTMLElement;
//   button.click();
// };

const handleFullscreenChanged = () => {
  videoFullscreen.value = !videoFullscreen.value;
};

// const handleCarouseUpdated = (value: string | number) => {
//   videoPlayerVisible.value = value === 1;
// };

const pageStore = usePageStore();
const page = computed(() => pageStore.page);

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);

const articleStore = useArticleStore();
const articles = computed(() => articleStore.articles);

const menus = computed(() => pageStore.menus);
const productPages = (id: string) => {
  const root = treeToList(menus.value, { pid: 'parentId' }).filter(
    (t: any) => t.id === id
  )[0];
  return root?.children ?? [];
};

const productsMap = computed(() => {
  const map = new Map<string, any[]>()
  const productsMenu = pageStore.menus?.find(menu => menu.title === 'Products & Solutions')
  productsMenu?.children?.forEach(child => {
    child?.children?.forEach(item => {
      map.set(item.title, item.children ?? [])
    })
  })
  return map
})

const products = (title: string) => {
  return productsMap.value.get(title) ?? []
}


const background = (image: string, size = 'cover') => {
  return image
    ? `background: url('${image}') no-repeat; background-size: ${size}; background-position: center center`
    : '';
};

const tiles = [
  {
    boxcls:
      'col-span-4 col-start-3 row-span-4 row-start-2 text-2xl 2xl:col-span-8 2xl:col-start-1 2xl:text-3xl',
    boxstyle: 'background:linear-gradient(225deg,#61b7b8,#0b357d)',
    cls: 'justify-center flex-col-reverse pl-4 2xl:pl-8 w-10/12',
    maincls: '',
  },
  {
    boxcls:
      'col-span-4 col-start-7 row-span-4 text-2xl 2xl:col-span-6 2xl:col-start-9 2xl:text-3xl',
    boxstyle: 'background:linear-gradient(222deg,#e9c946,#0b357d 94%)',
    cls: 'justify-center pl-4 2xl:pl-8 w-10/12',
  },
  {
    boxcls:
      'tile tile-l col-span-2 col-start-4 row-span-2 row-start-6 2xl:col-span-5 2xl:col-start-2 2xl:text-xl',
    cls: 'justify-center pl-4 2xl:pl-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dot',
  },
  {
    boxcls:
      'tile tile-l col-span-1 col-start-6 row-span-2 row-start-6 2xl:col-span-2 2xl:col-start-7 2xl:text-xl',
    cls: 'justify-center pl-4 2xl:pl-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dot',
  },
  {
    boxcls:
      'tile tile-r col-span-2 col-start-7 row-span-3 row-start-5 2xl:col-span-3 2xl:col-start-9 2xl:text-xl',
    cls: 'justify-center pl-4 pt-4 2xl:pl-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dash',
  },
  {
    boxcls:
      'tile tile-r col-span-2 col-start-9 row-span-3 row-start-5 2xl:col-span-3 2xl:col-start-12 2xl:text-xl',
    cls: 'justify-center pl-4 pt-4 2xl:pl-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dash',
  },
  {
    boxcls:
      'col-span-6 col-start-3 row-span-4 row-start-8 text-2xl 2xl:col-span-11 2xl:col-start-1 2xl:text-3xl',
    boxstyle: 'background:linear-gradient(225deg,#9b77f6,#1f0b7d)',
    cls: 'justify-center pl-4 py-4 2xl:pl-6 2xl:pt-6 w-10/12',
  },
  {
    boxcls:
      'tile-d col-span-3 col-start-3 row-start-12 2xl:col-span-5 2xl:col-start-1 2xl:text-xl',
    cls: 'pl-4 pt-4 2xl:pl-6 2xl:pt-6 w-10/12',  
    subcls: 'text-xs xl:text-xs',
    indicator: 'dropdown',
    Open: IndoorProductOpen
  },
  {
    boxcls:
      'tile-d col-span-2 col-start-6 row-start-12 2xl:col-span-4 2xl:col-start-6 2xl:text-xl',
    cls: 'pl-4 pt-4 2xl:pl-6 2xl:pt-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dropdown',
    Open: OutdoorProductOpen
  },
  {
    boxcls:
      'tile-d col-span-3 col-start-8 row-start-12 2xl:col-span-5 2xl:col-start-10 2xl:text-xl',
    cls: 'pl-4 pt-4 2xl:pl-6 2xl:pt-6 w-10/12',
    subcls: 'text-xs',
    indicator: 'dropdown',
    Open: CounterProductOpen
  },
  {
    boxcls:
      'tile tile-l col-span-2 col-start-5 row-span-1 2xl:col-span-3 2xl:col-start-4 2xl:text-xl',
    cls: 'pl-4 py-4 2xl:pl-8 2xl:py-8 w-10/12',
    subcls: 'text-xs',
    indicator: 'dot',
  },
];

const productOptions = computed(() => {
  const region = page.value?.regions?.find(
    (t: RegionDto) =>
      t.type === 'data-list' && t.extraProperties?.theme === '首页产品样式'
  );
  return (region?.children ?? [])
    .map((t: RegionDto) => ({ id: t.id, label: `${t.name} - ${t.summary}` }))
    .slice(2);
});

const formRef = ref();

const state = reactive({
  loading: false,
});

const model = reactive<ModelType>({
  name: '',
  country: undefined,
  company: undefined,
  content: '',
  phone: undefined,
  email: undefined,
  about: [],
  securityCode: undefined,
});

const vertification = process.env.VERTIFICATION;

const handleSubmit = async () => {
  state.loading = true;
  try {
    if (vertification === 'phone') {
      await vertifySmsSecurityCode(model.phone, model.securityCode);
      await create({
        ...model,
        about: model.about.join(','),
      });
    } else if (vertification === 'none') {
      await create({
        ...model,
        about: model.about.join(','),
      });
    }
    formRef.value?.[0]?.reset();
    Notify.create(t('Contact.form.notify'));
  } finally {
    state.loading = false;
  }
};

const handleReset = () => {
  model.name = '';
  model.company = '';
  model.content = '';
  model.phone = '';
  model.email = '';
  model.about = [];
  model.securityCode = '';
};

const onClickVideoButton = (e: Event, url: string) => {
  if (/^#/.test(url)) {
    e.stopPropagation();
    VueScrollTo.scrollTo(url, {
      offset: -144,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vue_video_player = _resolveComponent("vue-video-player")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createBlock(_component_q_page, {
    style: _normalizeStyle({
      transform: page.value.regions.some((t) => t.type === 'video-list')
        ? 'translateY(-5rem)'
        : null,
      'margin-bottom': '-5rem'
    })
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.regions, (region) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: region.id
        }, [
          (region.type === 'video-list')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(region.children?.filter((t) => t.isActive), (video) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: video.id,
                  class: "relative",
                  style: {"width":"calc(100vw)","height":"calc(100vw / 16.5 * 9)"}
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_vue_video_player, {
                      class: "video-player vjs-big-play-centered",
                      style: {"width":"calc(100vw)","height":"calc(100vw / 16.5 * 9)"},
                      src: video.image,
                      poster: video.image.replace(/\.mp4$/i, '.jpg'),
                      muted: !videoFullscreen.value,
                      controls: videoFullscreen.value,
                      volume: 0.6,
                      "playback-rates": [0.7, 1.0, 1.5, 2.0],
                      loop: true,
                      crossorigin: "anonymous",
                      playsinline: "",
                      onMounted: _cache[0] || (_cache[0] = ($event: any) => (handleMounted($event))),
                      onFullscreenchange: handleFullscreenChanged
                    }, null, 8, ["src", "poster", "muted", "controls"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    (video.summary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(video.summary), 1))
                      : _createCommentVNode("", true),
                    (video.url)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          class: "text-primary",
                          label: video.content,
                          outline: "",
                          "no-caps": "",
                          onClick: (e) => onClickVideoButton(e, video.url)
                        }, null, 8, ["label", "onClick"])), [
                          [_directive_scroll_to, '#message']
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (region.type === 'carousel')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (region.children?.length)
                  ? (_openBlock(), _createBlock(SvCarousel, {
                      key: 0,
                      modelValue: region.value,
                      "onUpdate:modelValue": ($event: any) => ((region.value) = $event),
                      regions: region.children!,
                      height: _unref(pageHeight),
                      class: "w-full",
                      "transition-prev": "jump-right",
                      "transition-next": "jump-left",
                      swipeable: "",
                      animated: "",
                      "control-color": "#fff",
                      "prev-icon": "mdi-chevron-left",
                      "next-icon": "mdi-chevron-right",
                      "navigation-icon": "mdi-radiobox-blank",
                      navigation: region.children?.length > 1,
                      arrows: region.children?.length > 1,
                      infinite: "",
                      padding: "",
                      autoplay: ""
                    }, {
                      "navigation-icon": _withCtx(({ active, onClick }) => [
                        active
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              class: "indicator w-14 h-2",
                              padding: "0",
                              dense: "",
                              onClick: onClick
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              class: "bg-gray-500 w-14 h-2",
                              padding: "0",
                              dense: "",
                              onClick: onClick
                            }, null, 8, ["onClick"]))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "regions", "height", "navigation", "arrows"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (region.type === 'product-list')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (region.extraProperties?.linkPageId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (isEnglish.value)
                          ? (_openBlock(), _createBlock(SvProductENTabs, {
                              key: 0,
                              class: "mt-8 mb-20",
                              pages: productPages(region.extraProperties.linkPageId)
                            }, null, 8, ["pages"]))
                          : (_openBlock(), _createBlock(SvProductTabs, {
                              key: 1,
                              class: "mt-8 mb-16",
                              pages: productPages(region.extraProperties.linkPageId)
                            }, null, 8, ["pages"]))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (region.type === 'document-list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (region.icon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: region.icon,
                            class: "w-8 h-8 mx-2 inline",
                            alt: region.name
                          }, null, 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(region.name), 1)
                    ]),
                    _createVNode(_component_router_link, {
                      to: "/news",
                      class: "flex items-center -gap-x-2 text-green-600"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('Index.more')), 1),
                        _createVNode(_component_q_icon, {
                          size: "20px",
                          name: "mdi-arrow-right-drop-circle-outline"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(SvDocumentCards, {
                    region: region,
                    articles: articles.value
                  }, null, 8, ["region", "articles"])
                ])
              ]))
            : _createCommentVNode("", true),
          (region.type === 'image-list')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (region.children?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (region.icon)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: region.icon,
                                  class: "w-8 h-8 mx-2 inline",
                                  alt: region.name
                                }, null, 8, _hoisted_16))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(region.name), 1)
                          ])
                        ]),
                        (region.type === 'image-list' && region.children?.length)
                          ? (_openBlock(), _createBlock(SvThumbnail, {
                              key: 0,
                              regions: region.children,
                              "grid-class": "2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2",
                              imageHeight: "108px",
                              ratio: "16/9",
                              flat: "",
                              row: 3,
                              "show-desc": false,
                              "show-dialog": false,
                              autoplay: ""
                            }, null, 8, ["regions"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (region.type === 'data-list')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                (region.extraProperties.theme === '首页产品样式')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "w-full flex justify-center items-center",
                      style: _normalizeStyle(`${background(region.image)}; height:${_unref(pageHeightTwo)}`)
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`grid grid-cols-14 grid-rows-${gridRow} gap-2 h-2/5 2xl:w-3/4 2xl:h-5/6 2xl:gap-4`),
                        style: _normalizeStyle(`grid-auto-rows: ${gridRowHeight.value};`)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (data, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: data.id,
                            class: _normalizeClass(`${tiles[i].boxcls} rounded-xl text-primary ${tiles[i].indicator === 'dropdown' ? (tiles[i].Open!.value ? 'row-span-4' : 'row-span-2') : ''}`),
                            style: _normalizeStyle(tiles[i].boxstyle),
                            onMouseenter: ($event: any) => (tiles[i].indicator === 'dropdown' ? tiles[i].Open!.value = true : null),
                            onMouseleave: ($event: any) => (tiles[i].indicator === 'dropdown' ? tiles[i].Open!.value = false : null)
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`relative w-full h-full flex justify-between ${
                    tiles[i].indicator === 'dash' ? 'flex-col' : ''
                  }`)
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(`flex flex-col ${tiles[i].cls} `)
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`tile-title ${tiles[i].maincls}`)
                                }, _toDisplayString(data.name), 3),
                                _createElementVNode("div", {
                                  class: _normalizeClass(`tile-summary ${tiles[i].subcls}`),
                                  innerHTML: data.summary.replace(/[\r\n]/g, '<br />')
                                }, null, 10, _hoisted_19)
                              ], 2),
                              (tiles[i].indicator === 'dot')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createVNode(_component_q_btn, {
                                      class: "tile-btn absolute right-2 top-2 animate__animated animate__fadeInLeft",
                                      to: data.url,
                                      icon: "mdi-chevron-right",
                                      size: "xs",
                                      round: "",
                                      flat: ""
                                    }, null, 8, ["to"])
                                  ]))
                                : (tiles[i].indicator === 'dash')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _hoisted_23,
                                      _createVNode(_component_q_btn, {
                                        class: "tile-btn animate__animated animate__fadeInLeft",
                                        to: data.url,
                                        icon: "mdi-chevron-right",
                                        size: "xs",
                                        round: "",
                                        flat: ""
                                      }, null, 8, ["to"])
                                    ]))
                                  : (tiles[i].indicator === 'dropdown')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _hoisted_24,
                                        (tiles[i].Open!.value)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "absolute top-12 left-0 w-full z-50 rounded-b-xl scrollbar-transparent",
                                              style: _normalizeStyle(`background-color: var(--bg-secondary);max-height: ${gridRowSelectHeight.value}; overflow-y: auto;`)
                                            }, [
                                              _createElementVNode("div", _hoisted_25, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products(data.name), (child) => {
                                                  return (_openBlock(), _createBlock(AppLink, {
                                                    key: child.title,
                                                    class: "mb-2 hover:text-highlight text-xs",
                                                    to: _unref(tmpl)(child.url, child),
                                                    title: child.title
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_26, _toDisplayString(child.title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to", "title"]))
                                                }), 128))
                                              ])
                                            ], 4))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (data.icon)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 3,
                                          class: "mt-4 mr-4 w-4 h-4 xl:w-6 xl:h-6 2xl:mt-6 2xl:mr-4 2xl:w-8 2xl:h-8",
                                          src: data.icon
                                        }, null, 8, _hoisted_27))
                                      : _createCommentVNode("", true)
                            ], 2)
                          ], 46, _hoisted_18))
                        }), 128))
                      ], 6)
                    ], 4))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (region.type === 'summary')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (region.extraProperties.theme === '首页交互')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "message",
                      class: "flex justify-center",
                      style: _normalizeStyle(`height:${_unref(pageHeight)}`)
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(region.name), 1),
                        _createVNode(_component_q_form, {
                          ref_for: true,
                          ref_key: "formRef",
                          ref: formRef,
                          class: "py-8 q-gutter-sm text-base 2xl:text-xl scrollbar-transparent",
                          onSubmit: handleSubmit,
                          onReset: handleReset,
                          style: _normalizeStyle(`
                max-height: calc(100vh); 
                overflow-y: auto;
                overflow-x: hidden;
              `)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_input, {
                              modelValue: model.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.name) = $event)),
                              label: _unref(t)('Contact.form.name'),
                              rules: [(val) => val && val.length > 0],
                              dark: dark,
                              dense: ""
                            }, null, 8, ["modelValue", "label", "rules"]),
                            _createVNode(_component_q_input, {
                              class: "flex-1",
                              modelValue: model.email,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.email) = $event)),
                              type: "tel",
                              label: _unref(t)('Contact.form.email.label'),
                              rules: [
                  (val) =>
                    (val &&
                      val.length > 0 &&
                      /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+(.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)*@([A-Za-z0-9]+(?:-[A-Za-z0-9]+)?.)+[A-Za-z0-9]+(-[A-Za-z0-9]+)?$/.test(
                        val
                      )) ||
                    _unref(t)('Contact.form.email.rules'),
                ],
                              dark: dark,
                              dense: ""
                            }, null, 8, ["modelValue", "label", "rules"]),
                            _createVNode(_component_q_input, {
                              modelValue: model.content,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.content) = $event)),
                              type: "textarea",
                              label: _unref(t)('Contact.form.content'),
                              rules: [(val) => val && val.length > 0],
                              dark: dark,
                              autogrow: "",
                              dense: ""
                            }, null, 8, ["modelValue", "label", "rules"]),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('Contact.form.about')), 1),
                            _createElementVNode("div", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productOptions.value, (product) => {
                                return (_openBlock(), _createBlock(_component_q_checkbox, {
                                  key: product.id,
                                  modelValue: model.about,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.about) = $event)),
                                  val: product.label,
                                  label: product.label,
                                  dark: dark,
                                  size: "sm"
                                }, null, 8, ["modelValue", "val", "label"]))
                              }), 128))
                            ]),
                            _createVNode(_component_q_btn, {
                              class: "w-full mt-4 text-base text-primary horizontal-gradient highlight hvr-grow-shadow",
                              dark: dark,
                              loading: state.loading,
                              type: "submit",
                              "no-caps": ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('Contact.form.submit')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})